import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { EYesNo } from '../../../../shared/models/types.enum';
import { SpinnerComponent } from '../../spinner/spinner.component';
import { RMSPlanReviewScheduleService } from '../../../../shared/services/rmsPlanReviewSchedule.service';

@Component({
  selector: 'review-rms-plan-schedule',
  standalone: true,
  imports: [
    CommonModule,
    SpinnerComponent
  ],
  templateUrl: './review-rms-plan-schedule.component.html',
  styleUrl: './review-rms-plan-schedule.component.css'
})
export class ReviewRmsPlanScheduleComponent implements OnInit {
  
  @Input() caseId: string | null = null;
  
  yesNo = EYesNo;
  rmsPlanScheduleForm: any | null = null;
  loading: boolean = false;
  
  sections = [
    {
      sectionName: "Schedule Review",
      children: [
        {
          type: 'date',
          questionText: "Planned Review Date:",
          answer: "review_session_date"
        },
        {
          type: 'string',
          questionText: "Review Coordinator:",
          answer: "review_coordinator_name"
        }
      ]
    },
    {
      sectionName: "Official Signature(s)",
      children: [
        {
          type: 'string',
          questionText: "Signature:",
          answer: "user_signature_name"
        },
        {
          type: 'string',
          questionText: "Name:",
          answer: "user_fullname"
        },
        {
          type: 'string',
          questionText: "Email address:",
          answer: "user_email"
        },
        {
          type: 'string',
          questionText: "Title:",
          answer: "user_title"
        },
        {
          type: 'string',
          questionText: "Workphone:",
          answer: "user_workphone"
        },
        {
          type: 'datetime',
          questionText: "Date & Time:",
          answer: "date_time_signed"
        }
      ]
    },
  ];

  constructor(
    private rmsPlanReviewScheduleService: RMSPlanReviewScheduleService
  ) { }

  ngOnInit(): void {
    this.loadRmsPlanScheduleForm();
  }

  loadRmsPlanScheduleForm(): void {
    if (this.caseId) {
      this.loading = true;
      this.rmsPlanReviewScheduleService.getRmsPlanReviewScheduleByCaseId(this.caseId).subscribe({
        next: (response) => {
          if (Object.keys(response).length === 0) {
            this.rmsPlanScheduleForm = null;
            this.loading = false;
            return
          } else {
            this.rmsPlanScheduleForm = response;
            this.loading = false;
            return
          }
        },
        error: (error) => {
          console.error('Error:', error);
        }
      });
    }
  }


  showYesNo(answer: number): string {
    switch (answer) {
      case 0: return 'No';
      case 1: return 'Yes';
      case 2: return 'Need More Information';
      default: return 'N/A';
    }
  }

}
